/* ==========================================================================
   SearcherFli > Client > Passenger > Constants
   ========================================================================== */

const ADULTS = 'adults';
const CHILDREN = 'children';
const BABIES = 'babies';

/* Exports */
module.exports = {
    ADULTS,
    CHILDREN,
    BABIES
};
